import { render } from "./CreateCase.vue?vue&type=template&id=399fc61c&scoped=true&ts=true"
import script from "./CreateCase.vue?vue&type=script&lang=ts"
export * from "./CreateCase.vue?vue&type=script&lang=ts"

import "./CreateCase.vue?vue&type=style&index=0&id=399fc61c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399fc61c"]])

export default __exports__